"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryCode = void 0;
var CountryCode;
(function (CountryCode) {
    CountryCode["Germany"] = "DE";
    CountryCode["Austria"] = "AT";
    CountryCode["Switzerland"] = "CH";
})(CountryCode || (exports.CountryCode = CountryCode = {}));
//# sourceMappingURL=CountryCode.js.map